import * as React from 'react'
import {translateCountryName, formatDate} from "@ui-seeker/utils";

import { RetailerBlock } from '@components';


export default function retailerColumn() {
	return [{
		name: 'date', label: 'Date',
		options: {
			display: 'excluded',
			customBodyRowRender: value => formatDate(value, { isString: true })
		}
	},{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: value => translateCountryName(value)
		}
	}, {
		name: 'externalSeller', label: 'Is 3P?',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'retailer', label: 'Retailer',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { country, date, siteURL }) => <RetailerBlock
				retailer={value}
				country={country}
				date={date}
				siteURL={siteURL}
			/>
		}
	}]
}